import React from 'react';
import {Component} from 'react';
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import favoriteQuestionOptions from './datasets/favorite_question_options';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import editPassword from '../../objects/CommonUse/edit_password';
import PasswordChecklist from "react-password-checklist"
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import setTempTokenForFetch from '../../objects/CommonUse/set_temp_token_for_fetch';
import DropDownOptionCard from '../shared-components/drop_down_option_card';

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class RegisterForm extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            favoriteQuestionArr: favoriteQuestionOptions,
            accountLoaded: false,
            loginLoaded: false,
            userCountLoaded: false,
            username: "",
            password: "",
            confirmPassword: "",
            test: false,
            openModal: false,
            rerender: false,
            openInfoModal: false,
            getLogonList: false,
            headers: "",
            subProcess: "RegisterForm",
            environment: Config.dataURL.currentEnv,
        };
        this.errorTable = [];
        this.userEdited = false;
        this.accountEdited = false;
        this.waiting = false;
        this.firstTime = true;
        this.saveLogin = false;
        this.editingComplete = false;
        this.gameRole = "player";
        this.resetErrorTable();
    }

   //   this is the full set of options for the password checker - have turned off several in this component
   // <PasswordChecklist
   //       rules={["minLength","specialChar",
   //             "number","capital","match"]}
   //               minLength={5}
   //               value={password}
   //               valueAgain={passwordAgain}
   //               />

    checkCurrentStatus(){
        if (this.editingComplete === false){
            this.waiting = true;
            if (this.props.signonType === "group"){
                this.editAccountInfo();
            }else{
                this.accountEdited = true;
            }
            this.editUsername();
            if (this.userEdited === true && this.accountEdited === true){
                this.waiting = false;
                if (this.errorsFound === true){
                    this.errorMessage = "Please correct errors and resubmit."
                }
            }
        }else{
            this.waiting = false;
        }
        if (this.accountEdited === true && this.userEdited === true){
            if (this.errorsFound === false){
                this.editingComplete = true;
                if (this.saveLogin === false){
                    this.waiting = true;
                    this.saveLoginUser();
                    this.saveLogin = true;
                }
            }else{
                this.editingComplete = true;
                this.waiting = false;
            }
        }
    }

       handleClickOutside = (event) => {
        if (!this.formRef.current) return;

            if (!this.formRef.current.contains(event.target)) {
                this.props.closeForm();
            }
        };
  

    render() { 
        if (this.editingComplete === false && this.errorsFound === false &&
            this.state.accountLoaded === true && this.state.loginLoaded === true){
                this.checkCurrentStatus();
        }

        
        const favoriteQuestions = this.state.favoriteQuestionArr.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
            );
    return <>
    
        <form ref={this.formRef} className="register-form px-2 pb-2" id="registerForm">
    
            <h4 className="text-left font-weight-bold">Create New Signon (Free)
                <img className="x-picture-size ml-4" src={'./assets/x-close.png'} alt="X"
                    onClick={()=>this.closeReleaseForm()}></img>
            </h4>
            {this.props.signonType === "group" ?
                <div className="font-weight-bold m-2">
                    Use this to create a signon that is associated with
                    a teacher (class) or parent (family).  
                    
                </div>
            :
                    <div className="font-weight-bold m-2">
                    Use this to create a signon that is <u>not</u> associated 
                    with a teacher (class) or parent (family).
                </div>
            }
                <ul className="bulleted-list">
                    <li>Suggest you use your first name as username.  Add a 
                        number to the end if the username is a duplicate.    </li>
                    <li>All entry fields are case sensitive.</li>
                    <li>Remember your password and security question answer!!!</li>
                </ul>
                {this.props.signonType === "group" ?
                <span>
                    
                    <div className="form-group text-left">
                        <label className="font-weight-bold">Account Number</label>
                        <input type="text" className="form-control" id="accountNbr" 
                            placeholder="AccountNbr"/>
                        <div className="text-danger font-weight-bold">{this.errorTable[0].message}</div>
                    </div>
                </span>
            :
                null
            }
            <div className="form-group text-left">
                <label className="font-weight-bold">New Username</label>
                <input type="text" className="form-control" id="newUsername" 
                    placeholder="Preferred username"/>
                <div className="text-danger font-weight-bold">{this.errorTable[1].message}</div>
            </div>
            <div className="form-group text-left mb-0">
                <label className="font-weight-bold">New Password</label>
                <input type="password" className="form-control" id="newPassword" 
                    placeholder="Password"
                    onChange={(val) => this.setPassword(val.target.value)}/>
                <div className="text-danger font-weight-bold">{this.errorTable[2].message}</div>
            </div>
            <div className="form-group text-left mb-0">
                <label className="font-weight-bold">Confirm Password</label>
                <input type="password" className="form-control" id="confirmPassword" placeholder="Confirm password"
                    onChange={(val) => this.setConfirmPassword(val.target.value)}/>
                <div className="text-danger font-weight-bold">{this.errorTable[3].message}</div>
            </div> 
            <PasswordChecklist
                    rules={["minLength","specialChar",
                        "match"]}
                    minLength={8}
                    value={this.state.password}
                    valueAgain={this.state.confirmPassword}
                />
            <div className="mt-3">
                <label className="font-weight-bold">Security Question (used for password reset): &nbsp;&nbsp;</label>
                <select 
                    className="btn btn-sm btn-outline-secondary dropdown-toggle" id="secQues"  >
                    {favoriteQuestions}
                </select>
                <div className="text-danger font-weight-bold">{this.errorTable[4].message}</div>
            </div>
            <div className="form-group text-left mb-0">
                <label className="font-weight-bold">
                    Security Question Answer: </label>
                <input type="text" className="form-control" id="secAnswer" placeholder="Security Question Answer"/>
                <div>(must be at least 6 characters long)</div>
                <div className="text-danger font-weight-bold">{this.errorTable[5].message}</div>
            </div>
                {this.errorsFound ?
                <div className="text-danger font-weight-bold">{this.errorMessage}</div>
            :
                null
            }
            <div className="form-group my-2 text-right">
                <button type="button" className="btn btn-primary" onClick={()=>this.submitNewId()}>Submit</button>
                <button type="button" className="ml-2 btn btn-primary" onClick={()=>this.closeReleaseForm()}>Close</button>
            </div>
            
            {this.waiting ?
                <WaitTimeSpinner/>
            :
                null
            }
    
        </form>
           
        </>
    }

    componentDidMount(){
        this._isMounted = true;
        setTimeout(() => {
            document.addEventListener("mousedown", this.handleClickOutside);
        }, 0);
    }

    
    componentWillUnmount(){
        document.removeEventListener("mousedown", this.handleClickOutside);
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    setSessionStorage(){
        sessionStorage.setItem('username', this.loginInfo.username);
        sessionStorage.setItem('userRole', this.loginInfo.role);
        sessionStorage.setItem('userAccountNbr', this.loginInfo.accountNbr);
        sessionStorage.setItem('defaultUserAccount', this.loginInfor.accountNbr);
        this.props.setInfoRedux(this.loginInfo.role, "playerRole")
    }

    submitNewId(){
        this.firstTime = false;
        this.editingComplete = false;
        if (this.props.signonType === "group"){
            let accountNbr = document.getElementById("accountNbr").value;
            this.accountNbr = accountNbr.replace(/\s/g, "");
        }else{
            this.accountNbr = "Individual";             
        }
        const username = document.getElementById("newUsername").value;
        const password = document.getElementById("newPassword").value;
        const confirmPassword = document.getElementById("confirmPassword").value;
        this.securityQuestion = document.getElementById("secQues").value;
        this.securityAnswer = document.getElementById("secAnswer").value;
        this.basicFieldEdits(username, password, confirmPassword);
        if (this.errorsFound === true){
            this.waiting = false;
            this.setState({rerender: !this.state.rerender});
        }else{
            this.setState({username: username, password: password, confirmPassword: confirmPassword});
        }
    }

    basicFieldEdits(username, password, confirmPassword){
        this.waiting = true;
        this.errorsFound = false;
        this.resetErrorTable();
        this.setState({openModal: true});
        if (this.props.signonType === "group"){
            if (this.accountNbr === ""){
                this.message = "Account number cannot be blank.";
                this.buildErrorTable(0);
            }else{
                this.getAccount();
            }
        }else{
            this.setState({accountLoaded: true});
            this.setState({userCountLoaded: true});
        }
        if (username === ""){
            this.message = "Username cannot be blank.";
            this.buildErrorTable(1);
        }else{
            const charArr = ['#', ';'];
            const invalidChars = charArr.join(',');
            if (charArr.some(char => username.includes(char))) {
                this.message = "Username cannot contain any of these special characters " + invalidChars + ".";
                this.buildErrorTable(1);
            }else{
                const usernameLowerCase = username.toLowerCase();
                if (usernameLowerCase === "username" || usernameLowerCase === "password"){
                    this.message = "Really?...Username must be creative.";
                    this.buildErrorTable(1);
                }else{
                    this.getLogin(username, password);
                }
            }
        }
        if (password === ""){
            this.message = "Password cannot be blank.";
            this.buildErrorTable(2);
        }else{
            let passwordErrors = editPassword(password, confirmPassword);
            if (passwordErrors[0].error === true){
                this.message = passwordErrors[0].message;
                this.buildErrorTable(2);
            }
            if (passwordErrors[1].error === true){
                this.message = passwordErrors[1].message;
                this.buildErrorTable(3);
            }
        }
        if (this.securityQuestion === "none"){
            this.message = "Security Question is required";
            this.buildErrorTable(4);
        }
        if (!this.securityAnswer || this.securityAnswer === ""){
            this.message = "Security Answer is required";
            this.buildErrorTable(5);
        }else{
            if (this.securityAnswer.length <= 5){
                this.message = "Security Answer must be at least 6 characters long.";
                this.buildErrorTable(5);
            }
            if (this.securityAnswer === "123456" || this.securityAnswer === "password"){
                this.message = "Security answer must be something creative.";
                this.buildErrorTable(5);
            }
        }
    }

    resetErrorTable(){
        this.errorTable = [
        {field: "account", error: false, message: ""},
        {field: "username", error: false, message: ""},
        {field: "password", error: false, message: ""},
        {field: "confirmPswd", error: false, message: ""},
        {field: "secQuestion", error: false, message: ""},
        {field: "secAnswer", error: false, message: ""}
       ]
       this.setState({accountLoaded: false, loginLoaded: false});
    }

    buildErrorTable(indx){
        this.errorTable[indx].error = true;
        this.errorTable[indx].message = this.message;
        this.errorsFound = true;
    }
    
    setPassword(password){
        this.setState({password: password});
    }

    setConfirmPassword(confirmPassword){
        this.setState({confirmPassword: confirmPassword});
    }

    editAccountInfo(){
        if (this.accountFound === false){
            this.message = "Invalid account number.";
            this.buildErrorTable(0);
        }else{
            if(this.gameRole !== "none"){
                this.checkPlayersArr();
            }
        }
        this.accountEdited = true;
    }

    checkPlayersArr(){
        if (this.nbrPlayersAlreadySignedUp === "demo"){
            this.message = "Cannot add " + this.gameRole + "s to this account (It is a demonstration account)."
            this.buildErrorTable(0);
        }
    }

    editUsername(){
        if (this.userFound === true)
        {
            this.message = "Username already exists, change username and resubmit";
            this.buildErrorTable(1);
        }
        this.userEdited = true;
      
    }
   
    closeReleaseForm(){
       this.props.closeForm();
    }
  
    getLogin(username, password){
        let headers = setTempTokenForFetch(username, password);
        const funcName = "loginChk";
        const rqstType = "UserOnly";
        const urlParm = "?rqstType=" + rqstType;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,
            {method:'GET',
                headers: headers
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            this.loginInfo = output.body;
                            if (this.loginInfo.result === "Username Found"){
                                this.userFound = true;
                            }else{
                                this.userFound = false;  
                            }
                            this.setState({loginLoaded: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    });
                };
            })
    }

    getAccount(){
        let headers = setTempTokenForFetch(this.state.username, this.state.password);
        const funcName = "loadAccount";
        const urlParm = "?accountNbr=" + this.accountNbr + "&tokenType=TempToken";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,
            {method:'GET',
             headers: headers,
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            this.accountInfo = output.body;
                            this.accountFound = true;
                            this.setState({accountLoaded: true});
                        }else{
                            if (statusCode === 250){
                                this.accountFound = false;
                                this.setState({accountLoaded: true});
                            }else{
                                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message};
                                this.props.processError(errorObj);
                            }
                        }
                    });
                };
            })
    }

    /*

    getUserLogonList(){
        let headers = setTempTokenForFetch(this.state.username, this.state.password);
        const funcName = "userCollectionList";
        const urlParm = "?accountNbr=" + this.accountNbr + 
            "&rqstType=CountOnly&gameRole=" + this.gameRole + "&tokenType=TempToken";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,
            {method:'GET',
            headers: headers})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            this.nbrPlayersAlreadySignedUp = output.body.result;
                            this.setState({userCountLoaded: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    });
                };
            })
    }
            */

    saveLoginUser(){
        const currDateTime = getCurrentDateTime();
        let headers = setTempTokenForFetch(this.state.username, this.state.password);
        let dataObject = {
            role: this.gameRole,
            accountNbr: this.accountNbr,
            securityQuestion: this.securityQuestion,
            securityAnswer: this.securityAnswer,
            dateAdded: currDateTime.date,
            dateUpdated: currDateTime.date
        };
        const funcName = "saveLoginUser";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,
        {
            method:'POST',
            headers: headers,
            body: JSON.stringify(dataObject)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.credentials = {username: this.state.username, password: this.state.password};
                        if (this.props.signonType === "group"){
                            this.confirmAccountUpdate();
                        }
                        this.waiting = false;
                        this.props.registerComplete(this.credentials);                      
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: dataObject};
                        this.props.processError(errorObj);
                    }
                });
            };
        })
    }
    
    confirmAccountUpdate(){
       // this.updateAccount();  - believe this can be removed fully but keeping in case
       //   it makes sense to add a 'usersSignedUp' count to the rqstdUsersArr
    }
    
    updateAccount(){
        const currDateTime = getCurrentDateTime();
        let tokenType = 'Standard';
        let headers = setTempTokenForFetch(this.state.username, this.state.password);
        tokenType = "TempToken";
     
        // Update account credit table in Mongo
        const bodyObj = {
            accountNbr: this.accountNbr,
            emailAddress: this.accountInfo.emailAddress,
            rqstdUsersArr: this.accountInfo.rqstdUsersArr,
            dateUpdated: currDateTime.date};
        const funcName = "updateAccount";
        const urlParm = "?tokenType=" + tokenType;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,
              {method:'PUT', headers: headers,
              body: JSON.stringify(bodyObj)})
              .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            this.waiting = false;
                            this.props.registerComplete();
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: bodyObj};
                            this.props.processError(errorObj);
                        }
                    });
                };
            })
    }
    
}

export default connect(null, mapDispatchToProps)(RegisterForm);